import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const Careers = dynamic(() => import('ui/pages/Careers'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/careers">
      <Careers/>
    </PageNextJs>
  );
};

export default Page;
